import React, { useEffect } from 'react';
import PageHeader from "../../components/PageHeader";
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { useGetDashboardQuery, useGetGraphQuery } from '../../redux/services/dashboardService';
// import './DashboardPage.css'; // Assuming you have a CSS file for custom styles

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const DashboardPage = () => {

    const { data: data2, isFetching, refetch } = useGetDashboardQuery()
    const dashboard = data2?.response?.data

    const { data: data3, } = useGetGraphQuery()
    const graph = data3?.response?.data

    function countByDate(data) {
        // Create an object to store date counts
        const dateCounts = {};

        // Loop through each item in data
        data?.forEach(item => {
            // Extract date portion from `created_at`
            const date = item.created_at.split('T')[0];

            // Initialize or increment the count for this date
            dateCounts[date] = (dateCounts[date] || 0) + 1;
        });

        // Convert the dateCounts object to an array of objects
        return Object.entries(dateCounts).map(([date, count]) => ({
            date,
            count
        }));
    }

    useEffect(() => {
        refetch()
    }, [])


    const data = {
        labels: countByDate(graph).map(item => item.date),
        datasets: [
            {
                label: 'Companies Created',
                data: countByDate(graph).map(item => item.count),
                fill: true,
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                tension: 0.4,
            }
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,
                    },
                },
            },
            title: {
                display: true,
                text: 'Company Created Over Time',
                font: {
                    size: 18,
                    weight: 'bold',
                },
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                grid: {
                    color: 'rgba(200, 200, 200, 0.2)',
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <>
            <PageHeader name="Dashboard" />
            <div className="main-container container-fluid">
                <div className="row pb-5">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex align-items-start">
                                            <div className="flex-grow-1">
                                                <p className="mb-0 text-muted">Total Companies</p>
                                                <h4 className="fw-bold">{dashboard?.total || 0}</h4>
                                            </div>
                                            <div className="min-w-fit-content ms-3">
                                                <span className="avatar avatar-md bg-primary text-white">
                                                    <i className="fe fe-briefcase fs-18" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex align-items-start">
                                            <div className="flex-grow-1">
                                                <p className="mb-0 text-muted">Active Companies</p>
                                                <h4 className="fw-bold text-success">{dashboard?.active || 0}</h4>
                                            </div>
                                            <div className="min-w-fit-content ms-3">
                                                <span className="avatar avatar-md bg-success text-white">
                                                    <i className="fe fe-check-circle fs-18" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex align-items-start">
                                            <div className="flex-grow-1">
                                                <p className="mb-0 text-muted">Inactive Companies</p>
                                                <h4 className="fw-bold text-danger">{dashboard?.inactive || 0}</h4>
                                            </div>
                                            <div className="min-w-fit-content ms-3">
                                                <span className="avatar avatar-md bg-danger text-white">
                                                    <i className="fe fe-x-circle fs-18" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-lg-12">
                                <div className="card shadow-sm">
                                    <div className="card-body" style={{ height: '400px' }}>
                                        <Line data={data} options={options} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardPage;
